// Configure PILLAR API with frontend-specific session handling
import {
    LEGAL_ACCEPTANCE_REQUIRED_HEADER,
    createPillarApiWithOptions,
    type PillarApiClient,
} from '@pillar-portal/api-types';
import { handleLegalAcceptanceRequired, handleSessionExpired } from './sessionManager';
import { setTraceContextHeader } from './logging/frontend-logger';

const pillarApi = createPillarApiWithOptions({
    onSessionExpired: handleSessionExpired,
    baseUrl: '/api',
    onTraceContext: setTraceContextHeader,
    enableIdempotencyHeaders: true,
    maxConcurrentRequests: 2,
    onResponse: (response: Response): void => {
        if (response.status === 403 && response.headers.has(LEGAL_ACCEPTANCE_REQUIRED_HEADER)) {
            handleLegalAcceptanceRequired();
        }
    },
});

export const authApi = pillarApi.authApi;
export const userApi = pillarApi.userApi;
export const organizationApi = pillarApi.organizationApi;
export const customerApi = pillarApi.customerApi;
export const paymentsInfrastructureApi: PillarApiClient['paymentsInfrastructureApi'] =
    pillarApi.paymentsInfrastructureApi;
export const sambaApi = pillarApi.sambaApi;
export const sambaConfigApi = pillarApi.sambaConfigApi;
export const diagnosticsApi = pillarApi.diagnosticsApi;
export const encryptionKeysApi = pillarApi.encryptionKeysApi;
export const secretsApi = pillarApi.secretsApi;
export const rpaCredentialInjectionApi = pillarApi.rpaCredentialInjectionApi;
export const ipxCredentialManagementApi = pillarApi.ipxCredentialManagementApi;
export const permissionsApi = pillarApi.permissionsApi;
export const authorizationApi = pillarApi.authorizationApi;
export const legalDocumentsApi = pillarApi.legalDocumentsApi;
export const legalAgreementsAdminApi = pillarApi.legalAgreementsAdminApi;
export const legalReportingApi = pillarApi.legalReportingApi;
export const myLegalAgreementsApi = pillarApi.myLegalAgreementsApi;
export const legalSurfacingApi = pillarApi.legalSurfacingApi;
export const auditApi = pillarApi.auditApi;
export const loggingApi = pillarApi.loggingApi;
export const paymentsApi = pillarApi.paymentsApi;
export const allowedWebsiteTemplatesApi = pillarApi.allowedWebsiteTemplatesApi;

// Re-export ApiError for backward compatibility
export { ApiError } from '@pillar-portal/api-types';
